import { RootState } from '../store';

export const selectSetCalendarError = (state: RootState) => state.calendar.error;
export const selectCalendarData = (state: RootState) => state.calendar.calendarData;